import { Injectable } from '@angular/core';

import { filter } from 'rxjs';

import { Store } from '@ngrx/store';

import { selectChatState, selectUser } from '../../../../store/app.selectors';

import { IUserProfile } from '../../../user/interfaces/IUserProfile';
import { IChannel, IChannelFilter } from '../../interfaces/IChannel';
import { IMessageableEntity } from '../../interfaces/IMessageableEntity';
import { IWorkspace } from '../../interfaces/IWorkspace';
import { AppStateWithChat } from '../../store/chat.reducer';

@Injectable()
export class MessagingApiStateService {
  channels: IChannel[] = [];
  channelsFilter: IChannelFilter;
  messagesFilter: { size: number };
  selectedChannel: IChannel | null = null;
  selectedWorkSpace: IWorkspace | null = null;
  user: IUserProfile | null = null;
  ownerId: string | undefined;
  users: IMessageableEntity[];

  constructor(private store: Store<AppStateWithChat>) {
    this.setUserSubscription();
    this.setChatSubscriptions();
  }

  private setChatSubscriptions(): void {
    this.store
      .select(selectChatState)
      .pipe(filter((data) => data !== undefined))
      .subscribe(({ selectedWorkSpace, selectedChannel, messagesFilter, channelsFilter, channels, users }) => {
        this.channels = channels;
        this.channelsFilter = channelsFilter;
        this.messagesFilter = messagesFilter;
        this.selectedChannel = selectedChannel;
        this.selectedWorkSpace = selectedWorkSpace;
        this.users = users;
      });
  }

  private setUserSubscription(): void {
    this.store.select(selectUser).subscribe((user) => {
      this.user = user;
      this.ownerId = this.user?.subjectMessageableEntity?.businessReference?.entityUID;
    });
  }
}
